import { reloadInitialData } from "store/slices/app";
import { useAppDispatch } from "components/shared/App";

export type ReloadInitialDataHook = () => void;

export default function useReloadInitialData(): ReloadInitialDataHook {
  const dispatch = useAppDispatch();

  return () => {
    dispatch(reloadInitialData());
  };
}
